import templateUrl from 'emun.promotion/promotions-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import config from "emun.promotion/promotion.config";


class PromotionsListController  {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
        let options = {
            url: 'QueryPromotionsJoin.json',
            pageSize: 12,
            autoLoad: true,
            append: false,
            sortOptions: {
                'Id': 'Code: 1 to 9',
                '-Id': 'Code: 9 to 1',
                'Description': 'Description: A to Z',
                '-Description': 'Description: Z to A'
            },
			filters: config.filters,
			hideLeftNav: true
        };
        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
    }
	load() { return this.query.load(); }

	create() {
		const $ctrl = this;
		$ctrl.$state.transitionTo("promotion",{ promoId: 'create' });
	}

    deletePromotion(m) {
        const $ctrl = this;
        return modals.confirm("Are you sure?", "Delete " + m.id).result.then(function () {
            return $ctrl.bus.send('DeletePromotion.json', m)
            .then(function (response) {
                $ctrl.query.load(true);
            });
        });
    };

}

let PromotionsList = {
    controller: PromotionsListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default PromotionsList;
